module.exports = __webpack_public_path__ + "static/media/blog5_2.0d824d37.webp";